import React, { FC, ReactNode } from 'react';

import { cn } from '../lib/utils';
import Typography from '../Typography/Typography';

type RichTextProps = {
  title?: string;
  description?: string | ReactNode;
  className?: string;
  dataTestId?: string;
  descriptionClassName?: string;
};

const RichText: FC<RichTextProps> = ({
  title,
  description,
  className,
  dataTestId,
  descriptionClassName
}) => {
  if (!title && !description) return null;

  return (
    <div
      className={cn('flex flex-col gap-1.5', className)}
      data-testid={dataTestId}
    >
      <Typography tag="h4" className={cn('text-base-foreground')}>
        {title}
      </Typography>
      <Typography
        className={cn(
          'text-p-m text-base-mutedForeground',
          descriptionClassName
        )}
      >
        {description}
      </Typography>
    </div>
  );
};

export default RichText;
